import { BillAction, BillStatus, type BillDTO } from '@invenco/common-interface/accounts';

import {
  AlertDialogWithAction,
  AlertDialogWithActionCancel,
  AlertDialogWithActionContent,
  AlertDialogWithActionDescription,
  AlertDialogWithActionFooter,
  AlertDialogWithActionHeader,
  AlertDialogWithActionSubmit,
  AlertDialogWithActionTitle,
  AlertDialogWithActionTrigger,
} from '@/components/alert-dialog-with-action';
import { Button } from '@/components/core/button';
import { useGateways } from '@/gateways/GatewayProvider';
import { useGatewayMutation } from '@/shared/hooks/queries';

export function BillActions({ bill }: { bill: BillDTO }) {
  const { accountsGateway } = useGateways();
  const canCloseBill = Boolean(
    bill.status !== BillStatus.CLOSED && bill.allowableActions?.includes(BillAction.CLOSE),
  );

  const { mutate: closeBill } = useGatewayMutation({
    mutationFn: () => accountsGateway.closeBill(bill.id),
    linkedQuery: ['bills', bill.id],
    linkResponseToQuery: false,
    successMessage: 'Bill closed successfully',
  });

  if (!canCloseBill) {
    return null;
  }

  return (
    <AlertDialogWithAction onAction={closeBill}>
      <AlertDialogWithActionTrigger asChild>
        <Button>Close</Button>
      </AlertDialogWithActionTrigger>
      <AlertDialogWithActionContent>
        <AlertDialogWithActionHeader>
          <AlertDialogWithActionTitle>Close this bill?</AlertDialogWithActionTitle>
          <AlertDialogWithActionDescription>
            A closed bill cannot be reopened. Continue only when all charges are final.
          </AlertDialogWithActionDescription>
        </AlertDialogWithActionHeader>
        <AlertDialogWithActionFooter>
          <AlertDialogWithActionCancel>Cancel</AlertDialogWithActionCancel>
          <AlertDialogWithActionSubmit>Close</AlertDialogWithActionSubmit>
        </AlertDialogWithActionFooter>
      </AlertDialogWithActionContent>
    </AlertDialogWithAction>
  );
}
